export default {
    SET_SUMMARY(state, data) { state.summary = data; },
    SET_PROPERTIES_BY_TYPE(state, data) { state.propertiesByType = data; },
    SET_PROPERTIES_BY_OBJECTIVE(state, data) { state.propertiesByObjective = data; },
    SET_PROPERTIES_BY_CONDITION(state, data) { state.propertiesByCondition = data; },
    SET_PROPERTIES_BY_LOCATION(state, data) { state.propertiesByLocation = data; },
    SET_TOP_PROPERTIES(state, data) { state.topProperties = data; },
    SET_PRICE_ANALYTICS(state, data) { state.priceAnalytics = data; },
    SET_AGENT_PERFORMANCE(state, data) { state.agentPerformance = data; },
    SET_MONTHLY_ACTIVITY(state, data) { state.monthlyActivity = data; },
    SET_MY_SUMMARY(state, data) { state.mySummary = data; },
}
